import { ReactNode, useEffect, useRef, useState } from 'react';
import './MarkdownContainer.scss';
import CopyButton from 'components/CopyButton/CopyButton';

interface MarkdownContainerProps {
  children: ReactNode;
  element: 'table' | 'pre';
}

const markdownContainerTitleMap = {
  table: 'Table',
  pre: 'Markdown',
} as const;

export const MarkdownContainer = ({ children, element }: MarkdownContainerProps) => {
  const contentElementRef = useRef<HTMLDivElement>(null);

  const [text, setText] = useState<undefined | string>('');

  useEffect(() => {
    setText(contentElementRef.current?.innerText);
  }, []);

  return (
    <div className="markdown-container">
      <div className="markdown-header">
        <span>{markdownContainerTitleMap[element]}</span>
        <CopyButton showCopyText={false} text={text} changeColor />
      </div>
      <div className="markdown-inner-content" ref={contentElementRef}>
        {children}
      </div>
    </div>
  );
};
